import React from 'react';
import { About } from '../components/About';
export function AboutPage() {
  return <main data-id="element-1261">
      <About data-id="element-1262" />
    </main>;
}